/** @format */

import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import ReactDOM from 'react-dom';
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { Router } from 'react-router';
import { Helmet } from 'react-helmet';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import ErrorBoundary from 'components/global/ErrorBoundary';
import LanguageContainer from 'components/layout/languagePicker/LanguageContainer';
import NavigationContainer from 'components/layout/navigation/NavigationContainer';
import history from 'utils/history';
import theme from './theme';
import combinedReducers from './reducers';
import 'index.css';

const middlewares = compose(applyMiddleware(thunk));
const store = createStore(combinedReducers, {}, middlewares);

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <ErrorBoundary>
        <Router history={history}>
          <Helmet>
            <script
              src='https://kit.fontawesome.com/ad9a19cd5e.js'
              crossOrigin='anonymous'
            ></script>
          </Helmet>
          <div>
            <LanguageContainer />
            <NavigationContainer hideLinks />
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: '1rem',
                fontSize: '1.5em'
              }}
            >
              <i className='fa fa-tools' />
              <p style={{ marginLeft: '1rem' }}>
                Maintenance ongoing...
                <br />
                Please reload the page in a few minutes
              </p>
            </div>
          </div>
        </Router>
      </ErrorBoundary>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
